<template>
  <section class="legacy-artists-section">
    <div class="flex justify-between items-center py-2 border-b border-gray-200">
      <h3>{{ $gettext('Artists') }}</h3>
      <router-link :to="{name: 'EventGroupArtistNew', params: { eventGroupId } }">
        {{ $gettext('Add Artist') }}
      </router-link>
    </div>
    <VPLoadingSpinner :loading="loading">
      <div class="artists-grid">
        <template
          v-for="eventArtist in eventArtists"
          :key="eventArtist.id"
        >
          <div>{{ eventArtist.artist?.name }}</div>
          <div>
            <router-link :to="{ name: 'EventGroupArtistEdit', params: { eventGroupId, artistId: eventArtist.artist?.id } }">
              {{ $gettext('Edit') }}
            </router-link>
          </div>
        </template>
      </div>
    </VPLoadingSpinner>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useEventArtistStore } from '@/stores/eventArtists';
import { VPLoadingSpinner } from '@vp/vue-components';
import { LoadingState } from '@/util/LoadingState';
import { useGettext } from 'vue3-gettext';

type Props = {
  eventGroupId: number | string;
};

const props = defineProps<Props>();

const eventArtistStore = useEventArtistStore();
const { $gettext } = useGettext();

const eventGroupId = computed(() => Number(props.eventGroupId));
const loading = computed(() => eventArtistStore.eventGroupArtistsLoading[props.eventGroupId] === LoadingState.LOADING);
const eventArtists = computed(() => eventArtistStore.eventGroupArtists[eventGroupId.value] || []);

onMounted(async () => {
  await eventArtistStore.loadEventGroupArtists(eventGroupId.value);
});
</script>
